<template>
  <section v-if="!isEmpty('user')" class="friends">
    <div class="info-block container-mobile">
      <div class="tabs">
        <div
          v-for="(tab, key) in computedTabs"
          @click="toggleTabs(tabs, key, updateTabObserver(key, tabs))"
          :key="key"
          class="tabs-item"
          :class="{ 'tabs-current': tab.selected }"
        >
          {{ tab.text }} <span class="count">{{ tab.count }}</span>
        </div>
      </div>

      <div class="friends-search">
        <input
          v-model="search"
          @input="getSearch"
          @change="getSearch"
          type="text"
          class="input"
          :placeholder="$t('threads.search')"
        />
      </div>

      <div v-if="tabs.friends.selected" class="friends-block">
        <div v-if="computedTabs.friends.loader">
          {{ $t("loading.loading") }}
        </div>
        <ul
          v-else-if="!friendsIsEmpty('friends')"
          class="friends-list friends-all user-list"
        >
          <li
            v-for="(friend, index) in friends"
            :ref="'friends' + index"
            :key="index"
            class="friends-item user-item"
            :class="{
              online: friend.online,
            }"
          >
            <router-link
              :to="'/profile/' + friend.id"
              :style="{
                'background-image': friend.avatar
                  ? 'url(' + friend.avatar + ')'
                  : '',
              }"
              class="user-item-avatar"
              :class="{
                'no-avatar': !friend.avatar,
              }"
            ></router-link>
            <div class="user-item-info">
              <router-link
                :to="'/profile/' + friend.id"
                class="user-item-title"
                >{{ friend.name }}</router-link
              >
              <div v-if="friend.city" class="user-item-subtitle">
                {{ friend.city }}
              </div>
              <div
                v-if="friend.i_am_blocked"
                @click="showWarning"
                class="user-item-bottom"
              >
                {{ $t("myFriends.inviteGame") }}
              </div>
              <InviteOpener
                v-else
                :id="friend.id"
                class="friends-invite-wrapper"
              ></InviteOpener>
            </div>
            <div class="user-item-right">
              <friendsContext
                :id="friend.id"
                :iAmBlocked="friend.i_am_blocked"
                :removeAvailable="true"
              ></friendsContext>
            </div>
          </li>
          <li v-if="moreLoader"><button class="button-loader"></button></li>
        </ul>
        <div v-else class="text">
          <span v-if="search.length < 3">{{
            $t("myFriends.friendsEmpty")
          }}</span>
          <span v-else>{{ $t("myFriends.noFriendsQuery") }}</span>
        </div>
      </div>
      <div v-if="tabs.friendsIncoming.selected" class="friends-block">
        <div v-if="computedTabs.friendsIncoming.loader">
          {{ $t("loading.loading") }}
        </div>
        <ul
          v-else-if="!friendsIncomingIsEmpty('friendsIncoming')"
          class="friends-list user-list"
        >
          <li
            v-for="(friend, index) in friendsIncoming"
            :ref="'friendsIncoming' + index"
            :key="index"
            class="friends-item user-item"
            :class="{
              online: friend.online,
            }"
          >
            <router-link
              :to="'/profile/' + friend.id"
              :style="{
                'background-image': friend.avatar
                  ? 'url(' + friend.avatar + ')'
                  : '',
              }"
              class="user-item-avatar"
              :class="{
                'no-avatar': !friend.avatar,
              }"
            ></router-link>
            <div class="user-item-info">
              <router-link
                :to="'/profile/' + friend.id"
                class="user-item-title"
                >{{ friend.name }}</router-link
              >
              <div v-if="friend.city" class="user-item-subtitle">
                {{ friend.city }}
              </div>
              <span class="user-item-bottom">
                {{ $t("myFriends.incomingApplication") }}
              </span>
            </div>
            <div class="user-item-right">
              <friendsButton
                :id="friend.id"
                :text="$t('myFriends.addFriend')"
                :textMobile="$t('myFriends.add')"
                action="friendsIncoming/accept"
                :successMessage="$t('myFriends.offerFriendshipAccepted')"
                :callback="get"
              ></friendsButton>
            </div>
          </li>
          <li v-if="moreLoader"><button class="button-loader"></button></li>
        </ul>
        <div v-else class="text">
          <span v-if="search.length < 3">{{
            $t("myFriends.applicationEmpty")
          }}</span>
          <span v-else>{{ $t("myFriends.noApplicationsRequest") }}</span>
        </div>
      </div>
      <div
        v-if="tabs.friendsOutgoing.selected"
        class="friends-block friends-outgoing"
      >
        <div v-if="computedTabs.friendsOutgoing.loader">
          {{ $t("loading.loading") }}
        </div>
        <ul
          v-else-if="!friendsOutgoingIsEmpty('friendsOutgoing')"
          class="friends-list user-list"
        >
          <li
            v-for="(friend, index) in friendsOutgoing"
            :ref="'friendsOutgoing' + index"
            :key="index"
            class="friends-item user-item"
            :class="{
              online: friend.online,
            }"
          >
            <router-link
              :to="'/profile/' + friend.id"
              :style="{
                'background-image': friend.avatar
                  ? 'url(' + friend.avatar + ')'
                  : '',
              }"
              class="user-item-avatar"
              :class="{
                'no-avatar': !friend.avatar,
              }"
            ></router-link>
            <div class="user-item-info">
              <router-link
                :to="'/profile/' + friend.id"
                class="user-item-title"
                >{{ friend.name }}</router-link
              >
              <div v-if="friend.city" class="user-item-subtitle">
                {{ friend.city }}
              </div>
              <span class="user-item-bottom">{{
                $t("myFriends.outgoingRequest")
              }}</span>
            </div>
            <div class="user-item-right">
              <friendsContext
                :id="friend.id"
                :iAmBlocked="friend.i_am_blocked"
                :removeAvailable="false"
              ></friendsContext>
            </div>
          </li>
          <li v-if="moreLoader"><button class="button-loader"></button></li>
        </ul>
        <div v-else class="text">
          <span v-if="search.length < 3">{{
            $t("myFriends.applicationEmpty")
          }}</span>
          <span v-else>{{ $t("myFriends.noApplicationsRequest") }}</span>
        </div>
      </div>
      <div v-if="tabs.blacklist.selected" class="friends-block">
        <div v-if="computedTabs.blacklist.loader">
          {{ $t("loading.loading") }}
        </div>
        <ul
          v-else-if="!blacklistIsEmpty('blacklist')"
          class="friends-list user-list"
        >
          <li
            v-for="(friend, index) in blacklist"
            :ref="'blacklist' + index"
            :key="index"
            class="friends-item user-item"
            :class="{
              online: friend.online,
            }"
          >
            <router-link
              :to="'/profile/' + friend.id"
              :style="{
                'background-image': friend.avatar
                  ? 'url(' + friend.avatar + ')'
                  : '',
              }"
              class="user-item-avatar"
              :class="{
                'no-avatar': !friend.avatar,
              }"
            ></router-link>
            <div class="user-item-info">
              <router-link
                :to="'/profile/' + friend.id"
                class="user-item-title"
                >{{ friend.name }}</router-link
              >
              <div v-if="friend.city" class="user-item-subtitle">
                {{ friend.city }}
              </div>
            </div>
            <div class="user-item-right">
              <friendsButton
                :id="friend.id"
                text="Удалить из черного списка"
                textMobile="Удалить"
                action="blacklist/remove"
                successMessage="Пользователь разблокирован"
              ></friendsButton>
            </div>
          </li>
          <li v-if="moreLoader"><button class="button-loader"></button></li>
        </ul>
        <div v-else class="text">
          <span v-if="search.length < 3">{{
            $t("myFriends.blacklistEmpty")
          }}</span>
          <span v-else>{{ $t("myFriends.noUsersQuery") }}</span>
        </div>
      </div>
    </div>
  </section>
  <section v-else>
    <div class="no-auth">
      {{ $t("auth.noAuth") }}
      <router-link class="link" tag="a" :to="{ name: 'home' }">{{
        $t("auth.noAuthLink")
      }}</router-link>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { toggleTabs } from "@/mixins/toggleTabs";
import friendsContext from "@/components/Blocks/FriendsContext";
import friendsButton from "@/components/Blocks/FriendsButton";
import { observeListEnd } from "@/mixins/observeListEnd";
import InviteOpener from "@/components/Blocks/InviteOpener";

export default {
  name: "Friends",
  props: {
    i18n: Object,
  },
  components: {
    friendsContext,
    friendsButton,
    InviteOpener,
  },
  mixins: [toggleTabs, observeListEnd],
  data() {
    return {
      localFriends: {},
      searchFriends: {},
      search: "",
      isSearch: false,
      tabs: {
        friends: {
          text: this.$t("myFriends.allFriends"),
          count: 0,
          selected: true,
          loader: true,
        },
        friendsIncoming: {
          text: this.$t("myFriends.incomingRequests"),
          count: 0,
          selected: false,
          loader: true,
        },
        friendsOutgoing: {
          text: this.$t("myFriends.outgoingRequests"),
          count: 0,
          selected: false,
          loader: true,
        },
        blacklist: {
          text: this.$t("myFriends.blackList"),
          count: 0,
          selected: false,
          loader: true,
        },
      },
      moreLoader: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "user/fetchUser",
      isEmpty: "user/isEmpty",
      friends: "friends/fetchFriends",
      friendsIsEmpty: "friends/isEmpty",
      friendsCount: "friends/fetchFriendsCount",
      friendsNext: "friends/fetchFriendsNext",
      friendsIncoming: "friendsIncoming/fetchIncoming",
      friendsIncomingIsEmpty: "friendsIncoming/isEmpty",
      friendsIncomingCount: "friendsIncoming/fetchIncomingCount",
      friendsIncomingNext: "friendsIncoming/fetchIncomingNext",
      friendsOutgoing: "friendsOutgoing/fetchOutgoing",
      friendsOutgoingIsEmpty: "friendsOutgoing/isEmpty",
      friendsOutgoingCount: "friendsOutgoing/fetchOutgoingCount",
      friendsOutgoingNext: "friendsOutgoing/fetchOutgoingNext",
      blacklist: "blacklist/fetchBlacklist",
      blacklistIsEmpty: "blacklist/isEmpty",
      blacklistCount: "blacklist/fetchBlacklistCount",
      blacklistNext: "blacklist/fetchBlacklistNext",
    }),
    computedTabs() {
      for (let key in this.tabs) {
        this.tabs[key].count = this[key + "Count"];
        this.tabs[key].next = this[key + "Next"];
      }
      return this.tabs;
    },
  },
  created() {
    this.get();
  },
  methods: {
    get(query = false) {
      for (let key in this.tabs) {
        let self = this;
        this.tabs[key].observer = new IntersectionObserver(
          function (entries) {
            if (entries[0].isIntersecting === true && self.tabs[key].selected) {
              self.showMore(key);
            }
          },
          { threshold: [0] }
        );

        this.$store
          .dispatch(key + "/get", query ? query : false)
          .then(() => {
            this.tabs[key].loader = false;
            this.isSearch = query ? true : false;
            this.updateMoreIndex(key);
            this.observeListEnd(key, this.tabs);
          })
          .catch(() => {
            this.tabs[key].loader = false;
          });
      }
    },
    getSearch() {
      if (this.search.length >= 3) {
        this.get(encodeURIComponent(this.search));
      } else if (this.isSearch) {
        this.get();
      }
    },
    updateMoreIndex(tab) {
      this.computedTabs[tab].moreIndex = this[tab].length - 2;
    },
    showMore(tab) {
      if (this.computedTabs[tab].next) {
        this.moreLoader = true;
        this.$store
          .dispatch(tab + "/getNext")
          .then(() => {
            this.observeListEnd(tab, this.tabs, true, true);
            this.moreLoader = false;
          })
          .catch(() => {
            this.moreLoader = false;
          });
      } else {
        this.observeListEnd(tab, this.tabs, true);
      }
    },
    showWarning() {
      this.$modal.show("dialog", {
        title: this.$t("threads.mistake"),
        text: this.$t("myFriends.userRestrictedInvitationsGames"),
        buttons: [
          {
            title: this.$t("roulette.ok"),
          },
        ],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/components/_tabs";
</style>

<style lang="scss">
@import "~@/assets/styles/pages/_friends";
</style>
